import { z } from 'zod';

import objectPassthrough from '../../objectPassthrough';
import { ProtectedValue } from '../ProtectedValue';

interface LoginCreditCard {
  number: string;
  cardHolder: string;
  expiration: string;
  securityCode: ProtectedValue;
  pin: ProtectedValue;
  displayType: string;
  displayMaskedNumber: string;
}

const LoginCreditCard = objectPassthrough({
  number: z.string(),
  cardHolder: z.string(),
  expiration: z.string(),
  securityCode: ProtectedValue,
  pin: ProtectedValue,
  displayType: z.string(),
  displayMaskedNumber: z.string(),
});

const LOGIN_CREDIT_CARD_KEYS = [
  'number',
  'cardHolder',
  'expiration',
  'securityCode',
  'pin',
  'displayType',
  'displayMaskedNumber',
] as const;

export { LoginCreditCard, LOGIN_CREDIT_CARD_KEYS };
